<template>

<!--	<Sidebar/>-->

	<Header/>

	<router-view/>

	<modals-container/>

	<Footer/>

</template>


<script>
import Header from './components/app-header'
import Footer from './components/app-footer'
// import Sidebar from './components/app-sidebar'

export default {
	// watch: {
		// $route(to, from) {
		// 	if (to.meta && typeof to.meta === 'object') {
		// 		if (to.meta.breadcrumbs) {
		// 		}
		// 	}
		// }
	// },
	components: {
		Header,
		Footer,
		// Sidebar,
	}
}
</script>
